import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { Trophy, ChevronDown, ChevronUp, Loader2 } from 'lucide-react';

export default function KmRanking({ eventId }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || data) return;
    const load = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const r = await axios.get(`${API}/events/${eventId}/ranking`, { headers: { Authorization: `Bearer ${token}` } });
        setData(r.data);
      } catch {
        setData({ ranking: [] });
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [open, data, eventId]);

  const medal = (pos) => (pos === 1 ? 'bg-yellow-400 text-yellow-900' : pos === 2 ? 'bg-gray-300 text-gray-800' : pos === 3 ? 'bg-amber-600 text-white' : 'bg-white text-gray-600 border border-gray-200');

  return (
    <div className="mt-3" data-testid={`km-ranking-${eventId}`}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between rounded-md bg-white border border-emerald-200 px-3 py-2.5 text-sm font-medium text-emerald-800 hover:bg-emerald-100"
        data-testid={`km-ranking-toggle-${eventId}`}
      >
        <span className="flex items-center gap-2"><Trophy className="w-4 h-4 text-yellow-500" /> Clasificación de kilómetros</span>
        {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
      {open && (
        <div className="mt-2 rounded-md bg-white border border-emerald-100 divide-y divide-gray-100">
          {loading && <p className="p-3 text-sm text-gray-500 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Cargando…</p>}
          {!loading && data?.ranking?.length === 0 && <p className="p-3 text-sm text-gray-500">Todavía no hay kilómetros registrados.</p>}
          {!loading && data?.ranking?.map(r => (
            <div key={r.registration_id} className={`flex items-center gap-3 px-3 py-2 ${r.is_me ? 'bg-orange-50' : ''}`} data-testid={`ranking-row-${r.position}`}>
              <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold shrink-0 ${medal(r.position)}`}>{r.position}</span>
              <span className="flex-1 min-w-0 truncate text-sm text-gray-800">
                {r.dorsal && <span className="font-mono text-orange-600 mr-1">#{r.dorsal}</span>}
                {r.name}{r.is_me && <span className="ml-1 text-xs text-orange-600 font-semibold">(tú)</span>}
              </span>
              <span className="text-sm font-bold text-emerald-700 whitespace-nowrap">
                {r.km.toLocaleString('es-ES', { maximumFractionDigits: 0 })} km
                {r.pct != null && <span className="text-xs font-normal text-gray-500 ml-1">{r.pct}%</span>}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
